// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__eOMIg","info":"UpdateTermsInfo_info__2H6vt"};